export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'Channel Link ID: ',
    },
    store_id: {
      label: 'ID posizione esterna: ',
    },
    store_provisioning_url: {
      label: 'URL di provisioning del negozio: ',
    },
  },
  buttons: {
    save: 'Salva',
  },
  toasts: {
    error: 'Salvataggio delle modifiche non riuscito',
    success: 'Modifiche salvate',
  },
  instructions: {
    title: 'Istruzioni di configurazione:',
    step_1:
      'Apri la pagina <Link>«Locations»</Link> in Deliverect, espandi la posizione corretta e clicca sul pulsante «+ Channel link».',
    step_2:
      'Compila le informazioni necessarie. Nel passaggio «Select your online delivery platform» seleziona «Food Amigos».',
    step_3: 'Completa tutti i passaggi. Poi, nella pagina «Locations», clicca su «Edit» sul canale «Food Amigos».',
    step_4: 'Nella barra laterale clicca sulla scheda «Channel connection» e inserisci questi dettagli:',
    step_5: 'Salva le modifiche cliccando sul pulsante «Save» in alto a destra.',
    step_6: "Una volta salvato, clicca sull'icona «More» in alto a destra, poi su «Register» e infine su «Activate».",
    step_7: 'Torna alla scheda «General», imposta lo «Integration status» su «Active» e salva le modifiche.',
    outro: 'Dopodiché puoi inviare il menu da Deliverect e creare un ordine di prova.',
  },
  connected: {
    title: 'Deliverect è connesso',
    description: 'Questa integrazione è configurata.',
  },
};
